import React from 'react';
import { Provider } from 'react-redux';
import { AuthProvider } from './contexts/AuthContext';
import { store } from './store/store';
import LoginForm from './components/LoginForm';
import ProductManager from './components/ProductManager';

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <div style={{ padding: '20px' }}>
          <h1>State Management Demo</h1>
          <LoginForm />
          <ProductManager />
        </div>
      </AuthProvider>
    </Provider>
  );
}

export default App;